import {BaseFactory} from "../factories/base-factory";
import {BaseModel} from "../models/base-model";
import {BaseApiResponseModel} from "../models/base-api-response-model";
import {BaseApiService} from "../domain-services/base-api-service";
import {BaseUtilsService} from "../domain-services/base-utils-service";
import {contractsUtils} from "../utils/contracts-utils";
import {DomUtils} from "../utils/dom-utils";
import {LoggerUtils} from "../utils/logger/logger-utils";
import {SiteConfig} from "../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../core/app/device.store";
import {BaseApiRequestParams} from "../models/params/base-api-request-params";
import {singleton} from "../decorators/singleton";

@singleton
export class BaseRepository extends BaseUtilsService {
  api: BaseApiService;
  factory: BaseFactory;
  items: Array<BaseModel>;

  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, BaseApiService, BaseFactory];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    api: BaseApiService,
    factory: BaseFactory
  ) {
    super(domUtils, logger, siteConfig, deviceStore);

    contractsUtils.requiredType(api, BaseApiService);
    contractsUtils.requiredType(factory, BaseFactory);

    this.factory = factory;
    this.api = api;
    this.items = [];
  }

  async fetch(params: BaseApiRequestParams, force = false, isFullDeltaResponse: Boolean = false): Promise {
    try {
      const request = this.api.fetch(params, force, isFullDeltaResponse);

      return request.promise.then((response): BaseApiResponseModel => this.createResponse(response, request));
    } catch (e) {
      this.logger.error(e);
    }
  }

  createResponse(apiModel: BaseApiResponseModel, request: BaseApiRequestParams): BaseApiResponseModel {
    const response = this.factory.createResponse(apiModel, request);

    return response;
  }

  findById(id) {
    const item = this.items.find(item => item.id === Number(id)) || this.items.find(item => item.ID === Number(id))

    return item;
  }

  findFirst() {
    const item = this.items[0];

    return item;
  }

  reset() {
    this.items.length = 0;
  }
}
